module.exports = __webpack_public_path__ + "img/career-02.35d5fbca.jpg";